// Public URL IDs stay stable; gameId is the database ID used by API requests.
export const DEFAULT_PUBLIC_GAME_ID = 19;

const routes = {
  19: { gameId: 20, home: "current" },
  20: { gameId: 19, home: "archive19" }
};

export function getShadowGameRoute(queryId) {
  const parsedId = Number(queryId);
  const publicId = Number.isInteger(parsedId) && parsedId > 0
    ? parsedId
    : DEFAULT_PUBLIC_GAME_ID;

  return {
    publicId,
    ...(routes[publicId] || { gameId: publicId, home: "current" })
  };
}
